module.exports = __webpack_public_path__ + "img/slide-news.f15aa8fc.jpg";